<template>
  <div>
    <v-snackbar v-model="showError" :timeout="timeout" color="red">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showError = false">
          Close
        </v-btn>
      </template>
      <p v-for="(error, index) of errors" :key="index">
        {{ error }}
      </p>
    </v-snackbar>
    <v-overlay z-index="10000" :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-form>
      <v-row justify="center">
        <v-col md="2">
          <v-select
            rounded
            solo
            :items="divisionList"
            label="Select a division"
            class="text-capitalize"
            v-model="division"
            clearable
          >
            <template v-slot:item="{ item }"
              ><span class="text-capitalize">{{ item }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col md="2">
          <v-select
            rounded
            solo
            :items="workerList"
            label="Select a worker"
            v-model="worker"
            class="text-capitalize"
            clearable
          >
            <template v-slot:item="{ item }"
              ><span class="text-capitalize">{{ item }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col md="2">
          <v-select
            rounded
            solo
            :items="entityList"
            label="Select an entity"
            v-model="entity"
            class="text-capitalize"
            clearable
          >
            <template v-slot:item="{ item }"
              ><span class="text-capitalize">{{ item }}</span>
            </template>
          </v-select>
        </v-col>
        <v-col md="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon large @click="search" v-bind="attrs" v-on="on">
                mdi-refresh
              </v-icon>
            </template>
            <span>Search</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="eventHubsHeaders"
            :items="eventHubs"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, -1]
            }"
            :items-per-page="50"
          >
            <template v-slot:item.topics="{ item }">
              <v-list dense>
                <v-list-item v-for="(topic, i) in item.topics" :key="i">
                  {{ topic.topic }}
                </v-list-item>
              </v-list>
            </template>
            <template v-slot:item.lags="{ item }">
              <v-list dense>
                <template v-for="topic in item.topics">
                  <v-list-item
                    v-for="(partition, j) in topic.partitions"
                    :key="j"
                  >
                    {{ partition.lag }}
                  </v-list-item>
                </template>
              </v-list>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('eventHubs');
export default {
  name: 'EventHubs',
  computed: {
    ...mapState(['loading', 'errors', 'eventHubs', 'eventHubsDefinitions']),
    divisionList() {
      if (this.eventHubsDefinitions) {
        return [
          ...new Set(this.eventHubsDefinitions.map(def => def.division).sort())
        ];
      }
      return [];
    },
    workerList() {
      if (this.eventHubsDefinitions && this.division) {
        return [
          ...new Set(
            this.eventHubsDefinitions
              .filter(def => def.division === this.division)
              .map(def => def.worker)
              .sort()
          )
        ];
      }
      return [];
    },
    entityList() {
      if (this.eventHubsDefinitions && this.division && this.worker) {
        return [
          ...new Set(
            this.eventHubsDefinitions
              .filter(
                def =>
                  def.division === this.division && def.worker === this.worker
              )
              .map(def => def.entity)
          )
        ];
      }
      return [];
    }
  },
  data() {
    return {
      timeout: 3000,
      showError: false,
      eventHubsHeaders: [
        { text: 'Div', value: 'division' },
        { text: 'Worker', value: 'worker' },
        { text: 'Entity', value: 'entity' },
        { text: 'Topic', value: 'topics' },
        { text: 'Lag', value: 'lags' }
      ],
      division: null,
      worker: null,
      entity: null
    };
  },
  watch: {
    errors(newValue) {
      this.showError = newValue.length > 0;
    }
  },
  async created() {
    await this.initEventHubDefinitions();
  },
  methods: {
    ...mapActions(['describeByDivision', 'initEventHubDefinitions']),
    async search() {
      if (this.division) {
        await this.describeByDivision({
          division: this.division,
          worker: this.worker,
          entity: this.entity
        });
      }
      return [];
    }
  }
};
</script>

<style></style>
